export const getFirstLibraryColumn = (getState) => {
  return getState().firestore.ordered.myCardLibrary.find((column) => column.position === 1);
}

export const getLibraryColumnById = (getState, libraryColumnId) => {
  return getState().firestore.ordered.myCardLibrary.find((column) => column.id === libraryColumnId);
}
